import React from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Line,
  LabelList,
} from "recharts";

const data = [
  { year: 2018, value: 55.3, percent: 45.3 },
  { year: 2019, value: 58.8, percent: 33.0 },
  { year: 2020, value: 67.5, percent: 33.0 },
  { year: 2021, value: 49.5, percent: 30.0 },
  { year: 2022, value: 45.7, percent: 29.0 },
  { year: 2023, value: 55.9, percent: 29.0 },
  { year: 2024, value: 62.4, percent: 29.0 },
  { year: 2025, value: 79.5, percent: 29.0 },
  { year: 2026, value: 84.3, percent: 29.0 },
];

function Financial() {
  return (
    <>
   
      <div className=" ">
      {/* <h1 className="chart ml-2 text-lg md:text-xl lg:text-2xl">Revenue</h1> */}
        <div className="w-[128%] max-w-8xl mx-auto bg-white">
        <h1 className="chart ml-2 text-lg md:text-xl lg:text-2xl mb-2 p-5">Revenue</h1>
          <ResponsiveContainer width="100%" height={300}>
            <ComposedChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="year" tickLine={false} axisLine={false} />
              <YAxis yAxisId="left" axisLine={false} tickLine={false} />
              <YAxis
                yAxisId="right"
                orientation="right"
                axisLine={false}
                tickLine={false}
                tickFormatter={(value) => `${value.toFixed(1)}%`}
              />
              <Tooltip />
              <Bar
                dataKey="value"
                fill="#923351"
                width={50}
                yAxisId="left"
                shape={(props) => {
                  const { x, y, width, height } = props;
                  return (
                    <g>
                      <defs>
                        <filter
                          id="shadow"
                          x="-20%"
                          y="-20%"
                          width="140%"
                          height="140%"
                        >
                          <feDropShadow
                            dx="2"
                            dy="2"
                            stdDeviation="3"
                            floodOpacity="0.3"
                          />
                        </filter>
                      </defs>
                      <rect
                        x={x}
                        y={y}
                        width={width}
                        height={height}
                        rx={5}
                        ry={5}
                        fill="#923351"
                        filter="url(#shadow)"
                      />
                    </g>
                  );
                }}
                barSize={50}
                barGap={20}
              >
                <LabelList
                  dataKey="value"
                  position="top"
                  fill="#000000"
                  fontFamily="Poppins, sans-serif"
                />
              </Bar>
              <Line
                type="monotone"
                dataKey="percent"
                stroke="#ff9c40"
                strokeWidth={2}
                dot={{ r: 0 }}
                yAxisId="right"
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
}

export default Financial;
